<div class="details-container">
  <div class="details-header" style="background: url(assets/images/bex2.jpg)">
    <div class="details-banner">
      <h1>The Latymer School</h1>
      <h2>11 Plus (11+) Exam Information</h2>
    </div>
  </div>

  <div class="details-publisher">
    <span><strong>Published by - SEHYOG Academy</strong></span>
  </div>

  <div class="details-content">
    <div class="details-section">
      <h3>Introduction</h3>

      <div class="spacer"></div>

      <p>
        The Latymer School is a highly respected, state-funded co-educational
        grammar school located in Edmonton, North London, just a short walk from
        Edmonton Green Overground station. With a student body of over 1,350
        pupils from a wide range of backgrounds, Latymer is known for its
        inclusive ethos and strong sense of community.
      </p>

      <div class="spacer"></div>

      <h2>A Curriculum That Inspires</h2>

      <p>
        The Latymer School follows the national curriculum while tailoring it
        each year to meet the evolving needs of its students. The school is
        committed to helping pupils discover and develop their talents across a
        broad range of subjects, encouraging independent thinking, critical
        analysis, and a love for learning.
      </p>

      <div class="spacer"></div>
      <h2>Beyond the Classroom</h2>

      <p>
        Latymer offers an extensive programme of extra- and super-curricular
        activities designed to support both personal and academic growth. Many
        of these activities are led and organised by students themselves, giving
        them the chance to build leadership skills and gain real-world
        experience in areas related to their future careers.
      </p>

      <div class="spacer"></div>
      <h2>A Balanced and Inclusive Education</h2>

      <p>
        At its core, The Latymer School aims to deliver a high-quality,
        balanced, and liberal education. Students are encouraged to reach their
        full potential while learning to show compassion, integrity, and respect
        for others. The school promotes a safe, welcoming environment where
        every pupil—regardless of their background, identity, or economic
        situation—can thrive.
      </p>

      <div class="spacer"></div>
      <h2>Preparing Students for the Future</h2>

      <p>
        Latymer pupils consistently achieve exceptional academic results and
        regularly secure places at top universities in the UK and beyond. This
        success is a reflection of the school’s commitment to both educational
        excellence and character development.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>The Latymer School 11 Plus (11+) Exam Information 2025</h2>

      <p><strong>Address: </strong>Haselbury Road, London N9 9TN</p>
      <p><strong>County:</strong> Hertfordshire/London Borough of Enfield</p>
      <p>
        <strong>Admissions info:</strong> office&#64;latymer.co.uk, 0208 807 4037
      </p>
      <p><strong>School type:</strong> Co-Educational Grammar</p>
      <p><strong> Number of pupils:</strong> 1,369</p>
      <p><strong>Number of places in Year 7:</strong> 186</p>
      <p><strong>11+ Exam date: </strong>September 2025</p>
      <p>
        <strong>Pass mark: </strong>Aim for 85%+ in our practice tests. See
        below for more details.
      </p>

      <p>
        <strong>Exam type / Board: Part One:</strong> GL Assessment| Part Two:
        set by the school
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>The Latymer School 11 Plus (11+) Admissions</h2>

      <div class="spacer"></div>

      <p>
        Admission to Year 7 at The Latymer School is based on academic selection
        through the 11 Plus examination. Due to the school’s high demand and
        outstanding reputation, Latymer typically receives over ten applications
        for every available place.<br />
      </p>
      <div class="spacer"></div>

      <h2>Visit the School</h2>

      <p>
        Before applying, parents and prospective students are strongly
        encouraged to attend one of the school’s open events or guided tours.
        These visits provide a valuable opportunity to explore the school’s
        environment and ethos, and to meet key staff members — including the
        Headteacher — in an informal setting.
      </p>

      <div class="spacer"></div>

      <h2>Oversubscription Criteria</h2>

      <p>
        When the number of applicants exceeds the available Year 7 places, the
        school applies the following oversubscription criteria in priority
        order: <br />
        <br />

        1. Children with an Education, Health & Care Plan (EHCP) that names The
        Latymer School. <br />
        2. Looked after children or previously looked after children. <br />
        3. Up to 20 applicants from the 'Inner Area' who demonstrate exceptional
        musical ability. <br />
        4. Up to 20 applicants from the 'Inner Area' who are eligible for the
        Pupil Premium. <br />
        <br />For full details about the application process, timelines, and
        definitions of the ‘Inner Area’, please refer to the school’s admissions
        policy or contact the admissions office directly.
      </p>

      <div class="spacer"></div>

      <h2>How to Apply for 11 Plus (11+) Entry to The Latymer School</h2>

      <p>
        In order to apply for a place at Latymer, parents are required to
        complete and return the school’s registration form as well as the local
        authority Common Application Form (CAF). <br />
        <br />

        Please note that late applications will not be accepted. If you fail to
        complete the school’s entry form on time, your child will not be able to
        take the entrance exam.
      </p>

      <h2>The Latymer School Catchment Area</h2>

      <p>
        Does The Latymer School have a catchment area? <br />
        <br />

        Yes, they do. For The Latymer School, Edmonton, priority catchment area
        is defined by the postal addresses of E2, E4, E5, E8, E9, E17, EN1, EN2,
        EN3, EN4, EN5 (Sectors 1, 2, 4, 5 only), EN8 (Sectors 7, 8, 9 only), N1
        (not N1C), N2, N3, N4, N5, N6, N7, N8, N9, N10, N11, N12, N13, N14, N15,
        N16, N17, N18, N19, N20, N21, and N22.
      </p>

      <h2>The Latymer School 11 Plus (11+) Exam Format</h2>

      <div class="spacer"></div>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>
          Part One: Mathematics and Verbal Reasoning. All applicants will be
          invited to take this test, which is multiple-choice, with a total
          duration of around 60 minutes.
        </p>
      </div>

      <div>
        <img src="assets/images/check-list.png" alt="" />
        <p>
          Part Two: The English test is split into two sections. Section one
          lasts 30 minutes and will consist of reading comprehension. Section
          two also lasts 30 minutes and will be a written paper, requiring
          pupils to tell a story and show a good level of writing skill.
        </p>
      </div>

      <h2>
        The Latymer School 11 Plus (11+) Exam Pass Marks and Target Scores
      </h2>

      <p>
        The Maths and Verbal Reasoning test will be marked first. Only the
        top-scoring 650 candidates will be eligible to have their English paper
        marked and then places will be offered to the top 192 candidates, based
        on their total score. <br />
        <br />

        There is no specific pass mark, but pupils who are able to score 85%+
        consistently in our 11+ practice tests should be on track to pass The
        Latymer School 11+ assessment. <br />
        <br />

        Whilst there are no guarantees, this has historically been a fairly
        strong indicator that your child should do well in The Latymer School
        11+ exam. Click here to learn about this school’s performance in
        comparison to other schools in the area. <br />
        br
      </p>

      <h2>How to Prepare for The Latymer School 11 Plus (11+) Exam?</h2>

      <p>
        One of the best ways to prepare for a competitive entrance exam is to
        use our practice tests. Getting to know the types of questions and the
        format of the actual exam will help boost your child’s confidence.
        <br />
        <br />

        Aside from becoming familiarised with the exam format, our practice
        papers will ensure that your child responds to the questions in an
        efficient and effective manner. <br />
        <br />

        They also provide an excellent opportunity for your child to practise
        working under time pressure. Whilst doing the tests under timed
        conditions, children can get used to answering questions quickly, with
        close attention to detail. <br />
        <br />

        Thoroughly researched and up to date, our recommendations to help your
        child prepare for The Latymer School 11 plus entrance examination can be
        found below.
      </p>
    </div>
  </div>
</div>
